import axios from "axios";
import { Client, Connection } from "../types/api";
import { loginRequest } from "../auth/msalConfig";
import { msalInstance } from "./msalInstance";
import { BASE_URL } from "./base";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(async (config) => {
  try {
    const account = msalInstance.getAllAccounts()[0];
    if (account) {
      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      config.headers.Authorization = `Bearer ${response.accessToken}`;
    }
  } catch (error) {
    console.error("Error acquiring token:", error);
  }
  return config;
});

export const getClientConnection = async (clientId: string, connectionId: string) => {
  console.log('Fetching connection:', connectionId);
  const response = await withErrorHandling(() => api.get<Connection>(`/clients/${clientId}/connections/${connectionId}`));
  console.log('Connection response:', response.data);
  return response.data;
};

export const getClient = async (clientId: string) => {
  console.log('Fetching client:', clientId);
  const response = await withErrorHandling(() => api.get<Client>(`/clients/${clientId}`));
  console.log('Connection response:', response.data);
  return response.data;
};

export const withErrorHandling = async <T>(axiosRequest: () => Promise<T>): Promise<T> => {
  try {
    return await axiosRequest();
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error('Error details:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        headers: error.response?.headers,
      });
      if (error.response?.data) {
        console.error('Error response data:', error.response.data);
      }
    } else {
      console.error('An unexpected error occurred:', error);
    }
    throw error;
  }
};